import { captureError } from '@smg-real-estate/browser-rum';
import { defineStore } from 'pinia';
import { ref } from 'vue';

import { getBillingContacts, type BillingContact } from '@/api/users';

export type { BillingContact } from '@/api/users';

export const useBillingContactsStore = defineStore('billingContacts', () => {
  const contacts = ref<BillingContact[]>([]);
  const isLoading = ref(false);
  const error = ref<Error | undefined>(undefined);

  async function fetchContacts(userId: string): Promise<void> {
    if (!userId) return;
    isLoading.value = true;
    error.value = undefined;
    try {
      contacts.value = await getBillingContacts(userId);
    } catch (e) {
      error.value = e instanceof Error ? e : new Error('Unknown error');
      captureError(e, { action: 'get-billing-contacts', userId });
    } finally {
      isLoading.value = false;
    }
  }

  function $reset() {
    contacts.value = [];
    isLoading.value = false;
    error.value = undefined;
  }

  return {
    contacts,
    isLoading,
    error,
    fetchContacts,
    $reset,
  };
});
